module.exports = __webpack_public_path__ + "static/media/Joan_icon_white.3f8349fc.svg";